function init() {

    // Function to check if a cookie exists
    function getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    // Function to close the modal
    function closeModal() {
        document.body.classList.remove('modal-open');

        // Get the data-id attribute from the body
        var bodyDataId = document.body.getAttribute('data-id');

        // Set a cookie with the data-id value
        setCookie('rf_modalClosed', bodyDataId, 7); // Cookie expires in 7 days
    }

    // Function to set a cookie
    function setCookie(name, value, days) {
        var expires = "";
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toUTCString();
        }
        document.cookie = name + "=" + (value || "") + expires + "; path=/";
    }

    // Check if the modal exists
    var modal = document.getElementById('pageModal');
    if (modal) {
        // Get the data-id attribute from the body
        var bodyDataId = document.body.getAttribute('data-id');
        
        // Check if the modalClosed cookie exists and matches the data-id
        var modalClosedCookie = getCookie('rf_modalClosed');
        if (modalClosedCookie === bodyDataId) {
            // If it matches, exit the function
            return;
        }

        // Open modal after delay
        setTimeout(function() {
            // Add the "modal-open" class to the body
            document.body.classList.add('modal-open');
        }, 1300);

        // If the cookie doesn't match, set up the close events
        document.getElementById('closeModal').addEventListener('click', closeModal);

        // Click event for outside the modal container
        document.addEventListener('click', function(event) {
            var modalContainer = document.querySelector('.o-modal__content');
            var isClickInside = modalContainer && modalContainer.contains(event.target);
            
            if (!isClickInside && modal.style.visibility !== 'hidden') {
                closeModal();
            }
        });
    }
    
}

export { init as default }